// extracted by mini-css-extract-plugin
export default {"ring":"spinner__ring__uDHs4","spin":"spinner__spin__vCJfU","tt":"spinner__tt__eXsWy"};